import AvatarWithName from "@/components/AvatarWithName";
import { DEFAULT_IMAGE_CARD } from "@/constants/image";
import { ProjectContext } from "@/context/project.context";
import { useAuth } from "@/hooks/useAuth";
import { IReviewItem } from "Models";
import { useContext } from "react";

let timeOutOpenUpload = null;
let timeOuteEmoji = null;
const BoxReply = ({ data }: { data: IReviewItem }) => {
  const { user } = useAuth();
  const {
    setCurrentShowFormReply,
    currentShowFormReply,
    refUpload,
    loadingSendReply,
  } = useContext(ProjectContext);

  return (
    <div className="flex items-center gap-3 w-full my-4">
      <AvatarWithName
        imageProps={{ resizeOnFly: false }}
        src={
          user?.avatar ? user?.avatar : user?.name ? null : DEFAULT_IMAGE_CARD
        }
        name={user?.name ?? "Ẩn danh"}
        avatarOnly
        imageClass="!w-10 !h-10"
        textClass="!text-white font-medium select-none"
        className="shrink-0"
      />
      <div
        className="flex items-center justify-between border border-solid border-grey-200 pl-4 pr-3 text-fs-14 text-grey-400 rounded-full w-full h-10 md:cursor-pointer bg-grey-50"
        onClick={(e) => {
          if (!loadingSendReply) {
            e.stopPropagation();
            if (currentShowFormReply !== data._id)
              setCurrentShowFormReply(data._id);
            else setCurrentShowFormReply(null);
          }
        }}>
        Phản hồi của bạn
        <div className="flex">
          <div
            className="h-9 w-9 flex items-center justify-center hover:bg-blue-100 hover:rounded-full"
            onClick={(e) => {
              if (!loadingSendReply) {
                e.stopPropagation();
                setCurrentShowFormReply(data._id);
                if (timeOutOpenUpload) clearTimeout(timeOutOpenUpload);
                timeOutOpenUpload = setTimeout(() => {
                  refUpload?.current?.click();
                });
              }
            }}>
            <i className="mrv mrv-add_photo_alternate text-blue-400 text-fs-18"></i>
          </div>
          <div
            className="h-9 w-9 items-center justify-center hover:bg-blue-100 hover:rounded-full hidden md:flex"
            onClick={(e) => {
              if (!loadingSendReply) {
                e.stopPropagation();
                setCurrentShowFormReply(data._id);
                if (timeOuteEmoji) clearTimeout(timeOuteEmoji);
                timeOuteEmoji = setTimeout(() => {
                  document.getElementById("btn-emoji")?.click();
                });
              }
            }}>
            <i className="mrv mrv-mood text-orange-400 text-fs-18 "></i>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoxReply;
